import React from 'react';
import { NavLink } from "react-router-dom";

function Operation() {

    return (
        <div className="operation-list">
            <div className="operation-name">
                <NavLink to="/http/probe" activeClassName="active">Probe</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/tokenise">Tokenise</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/validate">Validate</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/auth">Authorise</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/authsettle">Auth & Settle</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/tokenauth">Token Auth</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/tokensettle">Token Settle</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/tokenauthsettle">Token Auth & Settle</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/voidauth">Void Auth</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/checkout">Embedded</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/consolidated-ui">Consolidated UI</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/http/tokenrefund">Token Refund</NavLink>
            </div>
        </div>
    );
}

export default Operation;